import React, { useEffect, useMemo } from 'react';

import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import FormLabel from '@mui/material/FormLabel';
import { useForm } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { TitleFont } from '../../../libs/base/base-style';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import { Stack } from '@mui/system';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useHistory, useLocation } from 'react-router-dom';
import { useHorsesStore } from '../../../stores/horses'
import { FormTextField } from './FormInput'
import { toJS } from 'mobx'
type DetailsProps = {
    title: string;
    name?: string;
    email?: string;
    phone?: string;
    address?: string;
    profile_id: number;
    event_type: number;
    _ID: string;
}

const defaultValues = {
    last_visit: new Date(),
    reminder_date: new Date(),
    notes: '',
    event_type: 0,
    horse_id: 0,
};
const App: React.FC = (props) => {
    const stores = useHorsesStore()
    const { title, profile_id, event_type, _ID } = useLocation<DetailsProps>().state;

    useEffect(() => {
        console.log(toJS(stores.contacts.find(item => item._ID == _ID)))
    }, [])
    const methods = useForm({
        defaultValues: {
            ...toJS(stores.contacts.find(item => item._ID == _ID)),
            addr1: toJS(stores.contacts.find(item => item._ID == _ID))?.address.split(';')[0],
            addr2: toJS(stores.contacts.find(item => item._ID == _ID))?.address.split(';')[1],
            city: toJS(stores.contacts.find(item => item._ID == _ID))?.address.split(';')[2]
        }

    });
    const route = useHistory()
    const { handleSubmit, reset, control, setValue } = methods;
    const onSubmit = (data) => {
        console.log('update contact......')
        let addr1 = data.addr1 ? data.addr1 + ';' : ''
        let addr2 = data.addr2 ? data.addr2 + ';' : ''
        let city = data.city ? data.city : ''

        if (stores.contacts.find(item => item._ID == _ID)) {

            stores.updateContact({
                ...data,
                _ID: _ID,
                profile_id: String(profile_id),
                event_type: String(event_type),
                address: `${addr1}${addr2}${city}`
            })
        } else {//add new


            stores.addContact({
                ...data,
                profile_id: String(profile_id),
                event_type: String(event_type),
                address: `${addr1}${addr2}${city}`
            }).then(res => {
                if (res.success) {
                    route.goBack()
                }
            })
        }


    }

    return <Container >
        <Box mt={20}>
            <FormControl>
                <Grid container spacing={2} alignItems="center"
                    justifyContent="flex-start">
                    <StyledGrid item xs={12} mb={5} sx={{
                        justifyContent: {
                            xs: 'center',
                            sm: 'flex-start'
                        }
                    }}>
                        <VisitTitle>{`${title} Contact Details:`}</VisitTitle>
                    </StyledGrid>

                    <StyledGrid item xs={12} sm={6}>
                        <FormTextField control={control} name='name' label='' customLabel={<StyleFormLabel>Name:</StyleFormLabel>} disabled={stores.isEditingMode} />
                    </StyledGrid>
                    <StyledGrid item xs={12} sm={6}>
                        <FormTextField control={control} name='email' label='' customLabel={<StyleFormLabel>Email:</StyleFormLabel>} disabled={stores.isEditingMode} />
                    </StyledGrid>
                    <StyledGrid item xs={12} sm={6}>
                        <FormTextField control={control} name='phone' label='' customLabel={<StyleFormLabel>Phone:</StyleFormLabel>} disabled={stores.isEditingMode} />
                    </StyledGrid>
                    <StyledGrid item xs={12} mt={2}>
                        <Stack direction="row">
                            <StyleFormLabel>Address:</StyleFormLabel>
                        </Stack>
                    </StyledGrid>
                    <StyledGrid item xs={12}>
                        <FormTextField control={control} name='addr1' label='' customLabel={<StyleFormLabel2>Address Line 1:</StyleFormLabel2>} disabled={stores.isEditingMode} />
                    </StyledGrid>
                    <StyledGrid item xs={12}>
                        <FormTextField control={control} name='addr2' label='' customLabel={<StyleFormLabel2>Address Line 2:</StyleFormLabel2>} disabled={stores.isEditingMode} />
                    </StyledGrid>
                    <StyledGrid2 item xs={12}>
                        <FormTextField control={control} name='city' label='' customLabel={<StyleFormLabel2>City:</StyleFormLabel2>} disabled={stores.isEditingMode} />
                    </StyledGrid2>
                    <Stack direction="row" alignItems={'flex-start'} sx={{ width: '100%' }} mt={5} spacing={2} pl={{
                        xs: '16px',
                        sm: 'inherit'
                    }}>
                        {stores.contacts.find(item => item._ID == _ID) ?
                            <FillBtn variant='contained' onClick={handleSubmit(onSubmit, (err) => {
                                console.log('erro', err)
                            })}>Save Changes</FillBtn> :
                            <FillBtn variant='contained' onClick={handleSubmit(onSubmit, (err) => {
                                console.log('erro', err)
                            })}>Add Contact</FillBtn>
                        }

                        <TextBtn variant='text' endIcon={<ArrowForwardIosIcon sx={{ width: 12 }} />} onClick={route.goBack}>Go Back</TextBtn>
                    </Stack>


                </Grid>
            </FormControl>
        </Box>

    </Container>
}

const StyledBtn = styled(Button)`
    background-color: transparent !important;
    color:#408697 !important;
    font-size: 11px !important;
    text-transform: none !important;
    padding:0 !important;
    font-family: sans-serif;

`
const TextBtn = styled(StyledBtn)`
    font-size: 14px !important;
    padding:5px 25px !important;
`
const FillBtn = styled(Button)`
    color:white !important;
    font-size: 14px !important;
    border-radius:0 !important;
    padding:5px 25px !important;
    font-family: sans-serif;
    text-transform: none !important;
`

const Title = styled(TitleFont)(({ theme }) => ({
    fontSize: '35px',
    margin: '20px',
    fontWeight: 800,
    fontFamily: 'inherit',
    [theme.breakpoints.down('sm')]: {
        fontSize: '1.9rem',

    },
}));


const VisitTitle = styled(Title)`
    margin:0;
   
`
const SubTitle = styled(VisitTitle)`
    font-size:25px;
    margin-top:40px;
    margin-bottom:40px;
`
const StyledGrid = styled(Grid)`
    text-align:center;
    display: flex;
    align-items: center;
    justify-content: flex-start;
`
const StyledGrid2 = styled(Grid)`
    text-align:center;
    display: flex;
    justify-content: flex-start;
    align-items: center;
`
const StyleFormLabel = styled(FormLabel)`
    font-weight: 500 !important;
    color:#000 !important;
    font-size:18px !important;
    margin-right:20px !important;
    font-family: inherit !important;
    width:150px;
    line-height:100%;
`
const StyleFormLabel2 = styled(StyleFormLabel)`
color: #408697 !important;
font-size: 10px !important;
font-weight: 800 !important;
font-family: system-ui !important;
margin-right:auto;
`


export default App;